import React, { useState } from "react";
import { useMutation, useQuery } from "@apollo/client";

import {
  useMyOrgInfo,
  useLoginStatus,
  useUserInfo,
} from "../../../../Layout/AppMain/LoginStatusContext";
import {
  DELETE_ACTIVITY,
  UPDATE_PROJECT,
  GET_ALL_COUNTRIES,
  QUERY_GET_ALL_TARGET,
} from "../../../../queries";
import animetionLogo from "../../../../assets/utils/images/animetion_logo.gif";
import { DropdownList } from "react-widgets";
import { Multiselect } from "react-widgets";
import { setYear } from "date-fns";
import { Button, Modal } from "reactstrap";
import * as Ionicons from "react-icons/io";
import DeleteModalBody from "./DeleteModalBody";
import { color } from "@mui/system";

/**
 * 事業詳細ページ
 * @param {*} data
 * @returns
 */

const ActivityContent = (data) => {
  const {
    id,
    name,
    activityFields,
    beneficiaries,
    businessCost,
    businesses,
    country,
    sdgs,
    workers,
    year,
    target,
  } = data.data.node;

  const myPage = data.myPage;
  const { ability } = useUserInfo();
  const CloseIcon = Ionicons["IoIosClose"];
  const org_info = useMyOrgInfo();
  const user_id = useLoginStatus();
  const [bizNameEdit, setBizNameEdit] = useState(false);
  const [countryEdit, setCountryEdit] = useState(false);
  const [sdgsEdit, setSdgsEdit] = useState(false);
  const [workerEdit, setWorkerEdit] = useState(false);
  const [benefitEdit, setBenefitEdit] = useState(false);
  const [costEdit, setCostEdit] = useState(false);
  const [areaEdit, setAreaEdit] = useState(false);
  const [targetEdit, setTargetEdit] = useState(false);
  const [bizNumEdit, setBizNumEdit] = useState(false);
  const [yearEdit, setYearEdit] = useState(false);

  //   国名取得
  const { loading, error, data: allCountries } = useQuery(GET_ALL_COUNTRIES);

  // Get All Target
  const {
    loading: loadingTarget,
    error: errorTarget,
    data: allTarget,
  } = useQuery(QUERY_GET_ALL_TARGET);

  //   定款事業削除Mutation
  const [deleteAct, { loading: delete_act_loading, error: delete_act_error }] =
    useMutation(DELETE_ACTIVITY, {
      update(cache, { data: deletedAct }) {
        cache.modify({
          fields: {
            allActivity(exisitingAct, { readField }) {
              try {
                return exisitingAct.edges.filter(
                  (act) =>
                    deletedAct.deleteActivity.activity.id !==
                    readField("id", act)
                );
              } catch {
                window.location.reload();
              }
            },
          },
        });
      },
    });
  const deleteActibity = () => {
    deleteAct({
      variables: { activityId: id, orgId: org_info.id, userId: user_id },
    });
  };

  //   事業の更新Mutation
  let sdgsIds = [];
  for (let node of sdgs.edges) {
    sdgsIds.push(node.node.id);
  }
  let actFields = [];
  for (let node of activityFields.edges) {
    actFields.push(node.node.id);
  }
  let targetAudiences = [];
  for (let node of target.edges) {
    targetAudiences.push(node.node.id);
  }
  const [bizNum, setBizNum] = useState(businesses);
  const [new_name, setName] = useState(name);
  const [actIds, setActIds] = useState(activityFields);
  const [countryIds, setCountryIds] = useState(
    country.edges.map((ary) => ary.node.id)
  );
  const [worker, setWorker] = useState(workers);
  const [benefit, setBenefit] = useState(beneficiaries);
  const [bizCost, setBizCost] = useState(businessCost);
  const [sdgsId, setSdgsId] = useState(sdgsIds);
  const [newYear, setNewYear] = useState(year);
  const [actField, setActField] = useState(actFields);
  const [targetAudience, setTargetAudience] = useState(targetAudiences);

  // Sdgs選択用関数
  const addSdgsId = (id) => {
    setSdgsId([...sdgsId, id]);
  };
  const rmSDGsId = (id) => {
    let _list = [];
    for (let i of sdgsId) {
      if (i !== id) {
        _list.push(i);
      }
    }
    setSdgsId(_list);
  };

  // 活動分野の追加と削除
  const addActArea = (id) => {
    setActField([...actField, id]);
  };
  const rmActArea = (id) => {
    let _list = [];
    for (let i of actField) {
      if (i !== id) {
        _list.push(i);
      }
    }
    setActField(_list);
  };

  // Target Audience Activity
  const addTargetAudienceArea = (id) => {
    setTargetAudience([...targetAudience, id]);
  };
  const removeTargetAudienceArea = (id) => {
    let _list = [];
    for (let i of targetAudience) {
      if (i !== id) {
        _list.push(i);
      }
    }
    setTargetAudience(_list);
  };
  const [updAct, { loading: update_loading, error: update_error }] =
    useMutation(UPDATE_PROJECT);
  const updateActivity = async (setEdit, val, setVal) => {
    try {
      await updAct({
        variables: {
          activityId: id,
          userId: user_id,
          orgId: org_info.id,
          businesses: bizNum,
          name: new_name,
          workers: worker,
          beneficiaries: benefit,
          businessCost: bizCost,
          country: countryIds,
          sdgs: sdgsId,
          year: newYear,
          activityFields: actField,
          target: targetAudience,
        },
      });
    } catch (error) {
      alert(
        "入力内容に誤りがあります\n\n数値入力は、「 ,  」など数値以外の値を入力することができません。\n数値のみでご入力ください。"
      );
      // setVal(val);
    }
    await setEdit(false);
  };

  // 事業詳細削除モーダル
  const [deleteActtModal, setDeleteActtModal] = useState(false);
  const deleteActtModalToggle = () => setDeleteActtModal(!deleteActtModal);

  if (loading || update_loading || delete_act_loading || loadingTarget) {
    return (
      <div className="loading__wrapper" style={{ height: "50vh" }}>
        <img
          style={{ width: "80px", margin: "auto" }}
          src={animetionLogo}
        ></img>
      </div>
    );
  }

  // 活動国選択
  let doropdownData = allCountries.countries.edges.map((edge) => ({
    id: edge.node.id,
    color: edge.node.nameJp,
  }));

  let CountryDefaultVal = [];
  country.edges.map((ary) => {
    CountryDefaultVal.push(doropdownData.find(({ id }) => id === ary.node.id));
  });

  return (
    <>
      {myPage && ability == "can_edit" && ability == "can_edit" ? (
        <div style={{ textAlign: "right" }}>
          <span
            className="lnr lnr-trash pointer mr-2 ema__color__red"
            style={{ fontSize: 16 }}
            onClick={() => deleteActtModalToggle()}
          ></span>
          <Modal isOpen={deleteActtModal} toggle={deleteActtModalToggle}>
            <DeleteModalBody
              deleteFunc={deleteActibity}
              deleteObjTitle={name}
            />
          </Modal>
        </div>
      ) : (
        <></>
      )}

      <table
        style={{
          border: "solid 1px #dedfec",
          width: "100%",
          borderCollapse: "collapse",
        }}
        className="mb-3 ema__actcontent"
      >
        <tr style={{ fontSize: "13.2px", borderBottom: "solid 1px #dedfec" }}>
          <th className="py-2 pl-2 ema__act_th">活動年度</th>
          <td>
            {myPage && ability == "can_edit" && yearEdit ? (
              <>
                <input
                  onChange={(e) => {
                    setNewYear(e.target.value);
                  }}
                  value={newYear}
                />
                <Button
                  className="ema__btn__sm_update mx-2"
                  // className="pointer ml-2"
                  onClick={(e) => {
                    updateActivity(setYearEdit, year, setYear);
                  }}
                >
                  更新
                </Button>
                <CloseIcon
                  fontSize="17px"
                  onClick={(e) => {
                    setYearEdit(!yearEdit);
                  }}
                />
              </>
            ) : (
              <>
                {year}
                {myPage && ability == "can_edit" && (
                  <span
                    onClick={() => setYearEdit(!yearEdit)}
                    className="lnr lnr-pencil ema__color__blue pointer ml-2"
                  ></span>
                )}
              </>
            )}
          </td>
        </tr>
        <tr style={{ fontSize: "13.2px", borderBottom: "solid 1px #dedfec" }}>
          <th className="py-2 pl-4" style={{ width: "12%" }}>
            事業名
          </th>
          <td>
            {myPage && ability == "can_edit" && bizNameEdit ? (
              <>
                <input
                  onChange={(e) => {
                    setName(e.target.value);
                  }}
                  value={new_name}
                />
                <Button
                  className="ema__btn__sm_update mx-2"
                  // className="pointer ml-2"
                  onClick={(e) => {
                    updateActivity(setBizNameEdit, name, setName);
                  }}
                >
                  更新
                </Button>
                <CloseIcon
                  fontSize="17px"
                  onClick={(e) => {
                    setBizNameEdit(!bizNameEdit);
                  }}
                />
              </>
            ) : (
              <>
                {name}
                {myPage && ability == "can_edit" && (
                  <span
                    onClick={() => setBizNameEdit(!bizNameEdit)}
                    className="lnr lnr-pencil ema__color__blue pointer ml-2"
                  ></span>
                )}
              </>
            )}
          </td>
        </tr>
        <tr style={{ fontSize: "13.2px", borderBottom: "solid 1px #dedfec" }}>
          <th className="py-2 pl-4" style={{ width: "12%" }}>
            活動国
          </th>
          {myPage && ability == "can_edit" && countryEdit ? (
            <td style={{ display: "flex", alignItems: "center" }}>
              <span style={{ flexBasis: "40%" }}>
                <Multiselect
                  dataKey="id"
                  textField="color"
                  data={doropdownData}
                  // defaultValue={country.edges.map((ary) => ary.node.nameJp)}
                  defaultValue={CountryDefaultVal}
                  onChange={(e) => {
                    setCountryIds(e.map((ary2) => ary2.id));
                  }}
                />
              </span>
              <Button
                className="ema__btn__sm_update mx-2"
                onClick={(e) =>
                  updateActivity(
                    setCountryEdit,
                    country.edges.map((ary) => ary.node.id),
                    setCountryIds
                  )
                }
              >
                更新
              </Button>
              <CloseIcon
                fontSize="17px"
                onClick={(e) => {
                  setCountryEdit(!countryEdit);
                }}
              />
            </td>
          ) : (
            <td>
              {/* {countries && countries.nameJp} */}
              {country.edges.map((ary, index) => ary.node.nameJp + ", ")}
              {myPage && ability == "can_edit" && (
                <span
                  className="lnr lnr-pencil ema__color__blue pointer ml-2"
                  onClick={() => setCountryEdit(!countryEdit)}
                ></span>
              )}
            </td>
          )}
        </tr>
        <tr style={{ fontSize: "13.2px", borderBottom: "solid 1px #dedfec" }}>
          <th className="py-2 pl-4" style={{ width: "12%" }}>
            SDGs
          </th>
          <td>
            {myPage && ability == "can_edit" && sdgsEdit ? (
              <>
                {allCountries.allSdgs.edges.map((item) => {
                  if (sdgsId.includes(item.node.id)) {
                    return (
                      <img
                        className="px-1 mb-2 pointer"
                        style={{ width: "2.5rem" }}
                        src={item.node.logoUrl}
                        onClick={(e) => {
                          rmSDGsId(item.node.id);
                        }}
                        key={item.node.id}
                      />
                    );
                  } else {
                    return (
                      <img
                        className="px-1 mb-2 pointer"
                        style={{ width: "2.5rem", opacity: "0.2" }}
                        src={item.node.logoUrl}
                        onClick={(e) => {
                          addSdgsId(item.node.id);
                        }}
                        key={item.node.id}
                      />
                    );
                  }
                })}
                <Button
                  className="ema__btn__sm_update"
                  onClick={() => updateActivity(setSdgsEdit, sdgs, setSdgsId)}
                >
                  更新
                </Button>
                <CloseIcon
                  fontSize="17px"
                  onClick={(e) => {
                    setSdgsEdit(!sdgsEdit);
                  }}
                />
              </>
            ) : (
              <>
                {sdgs.edges.map((node, index) => (
                  <>
                    <img
                      className="px-1"
                      style={{ width: "2.5rem" }}
                      src={node.node.logoUrl}
                      key={index}
                    />
                  </>
                ))}
                {myPage && ability == "can_edit" && (
                  <span
                    className="lnr lnr-pencil ema__color__blue pointer ml-2"
                    onClick={() => setSdgsEdit(!sdgsEdit)}
                  ></span>
                )}
              </>
            )}
          </td>
        </tr>
        <tr style={{ fontSize: "13.2px", borderBottom: "solid 1px #dedfec" }}>
          <th className="py-2 pl-4 activity_content" style={{ width: "12%" }}>
            <span style={{ position: "relative", display: "flex" }}>
              事業数
            </span>
          </th>
          <td>
            {myPage && ability == "can_edit" && bizNumEdit ? (
              <>
                <input
                  onChange={(e) => {
                    setBizNum(e.target.value);
                  }}
                  value={bizNum}
                />
                <Button
                  className="ema__btn__sm_update mx-2"
                  onClick={(e) =>
                    updateActivity(setBizNumEdit, businesses, setBizNum)
                  }
                >
                  更新
                </Button>
                <CloseIcon
                  fontSize="17px"
                  onClick={(e) => {
                    setBizNumEdit(!bizNumEdit);
                  }}
                />
              </>
            ) : (
              <>
                {Number(businesses).toLocaleString()}
                {myPage && ability == "can_edit" && (
                  <span
                    className="lnr lnr-pencil ema__color__blue pointer ml-2"
                    onClick={() => setBizNumEdit(!bizNumEdit)}
                  ></span>
                )}
              </>
            )}
          </td>
        </tr>
        <tr style={{ fontSize: "13.2px", borderBottom: "solid 1px #dedfec" }}>
          <th className="py-2 pl-4" style={{ width: "12%" }}>
            <span style={{ position: "relative", display: "flex" }}>
              従事者数
            </span>
          </th>
          <td>
            {myPage && ability == "can_edit" && workerEdit ? (
              <>
                <input
                  onChange={(e) => {
                    setWorker(e.target.value);
                  }}
                  value={worker}
                />
                <Button
                  className="ema__btn__sm_update mx-2"
                  onClick={(e) => {
                    updateActivity(setWorkerEdit, workers, setWorker);
                  }}
                >
                  更新
                </Button>
                <CloseIcon
                  fontSize="17px"
                  onClick={(e) => {
                    setWorkerEdit(!workerEdit);
                  }}
                />
              </>
            ) : (
              <>
                {Number(workers).toLocaleString()}
                {myPage && ability == "can_edit" && (
                  <span
                    className="lnr lnr-pencil ema__color__blue pointer ml-2"
                    onClick={() => setWorkerEdit(!workerEdit)}
                  ></span>
                )}
              </>
            )}
          </td>
        </tr>
        <tr style={{ fontSize: "13.2px", borderBottom: "solid 1px #dedfec" }}>
          <th className="py-2 pl-4" style={{ width: "12%" }}>
            <span style={{ position: "relative", display: "flex" }}>
              受益者数
            </span>
          </th>
          <td>
            {myPage && ability == "can_edit" && benefitEdit ? (
              <>
                <input
                  onChange={(e) => {
                    setBenefit(e.target.value);
                  }}
                  value={benefit}
                />
                <Button
                  className="ema__btn__sm_update mx-2"
                  onClick={(e) => {
                    updateActivity(setBenefitEdit, beneficiaries, setBenefit);
                  }}
                >
                  更新
                </Button>
                <CloseIcon
                  fontSize="17px"
                  onClick={(e) => {
                    setBenefitEdit(!benefitEdit);
                  }}
                />
              </>
            ) : (
              <>
                {Number(beneficiaries).toLocaleString()}
                {myPage && ability == "can_edit" && (
                  <span
                    className="lnr lnr-pencil ema__color__blue pointer ml-2"
                    onClick={() => setBenefitEdit(!benefitEdit)}
                  ></span>
                )}
              </>
            )}
          </td>
        </tr>
        <tr style={{ fontSize: "13.2px", borderBottom: "solid 1px #dedfec" }}>
          <th className="py-2 pl-4" style={{ width: "12%" }}>
            <span style={{ position: "relative", display: "flex" }}>
              事業費
            </span>
          </th>
          <td>
            {myPage && ability == "can_edit" && costEdit ? (
              <>
                <input
                  onChange={(e) => {
                    setBizCost(e.target.value);
                  }}
                  value={bizCost}
                />
                <Button
                  className="ema__btn__sm_update mx-2"
                  onClick={(e) => {
                    updateActivity(setCostEdit, businessCost, setBizCost);
                  }}
                >
                  更新
                </Button>
                <CloseIcon
                  fontSize="17px"
                  onClick={(e) => {
                    setCostEdit(!costEdit);
                  }}
                />
              </>
            ) : (
              <>
                {Number(businessCost).toLocaleString()}
                {myPage && ability == "can_edit" && (
                  <span
                    className="lnr lnr-pencil ema__color__blue pointer ml-2"
                    onClick={() => setCostEdit(!costEdit)}
                  ></span>
                )}
              </>
            )}
          </td>
        </tr>
        <tr style={{ fontSize: "13.2px", borderBottom: "solid 1px #dedfec" }}>
          <th className="py-2 pl-4" style={{ width: "12%" }}>
            対象分野
          </th>
          <td>
            {myPage && ability == "can_edit" && areaEdit ? (
              <>
                {allCountries.allActivityfields.edges.map((item, index) => {
                  if (actField.includes(item.node.id)) {
                    return (
                      <Button
                        key={index}
                        className="mr-1"
                        style={{
                          background: item.node.color,
                          border: "none",
                          color: "#fff",
                          marginBottom: 3,
                        }}
                        onClick={(e) => {
                          rmActArea(item.node.id);
                        }}
                      >
                        {item.node.name}
                      </Button>
                    );
                  } else {
                    return (
                      <Button
                        key={index}
                        className="mr-1"
                        style={{
                          background: "#b9b9b9",
                          border: "none",
                          color: "#fff",
                          marginBottom: 3,
                        }}
                        onClick={(e) => {
                          addActArea(item.node.id);
                        }}
                      >
                        {item.node.name}
                      </Button>
                    );
                  }
                })}
                <Button
                  className="ema__btn__sm_update mx-2"
                  onClick={() =>
                    updateActivity(setAreaEdit, activityFields, setActField)
                  }
                >
                  更新
                </Button>
                <CloseIcon
                  fontSize="17px"
                  onClick={(e) => {
                    setAreaEdit(!areaEdit);
                  }}
                />
              </>
            ) : (
              <>
                {activityFields.edges.map((item, index) => (
                  <>
                    <Button
                      key={index}
                      className="mr-1"
                      style={{
                        background: item.node.color,
                        border: "none",
                        color: "#fff",
                        marginBottom: 3,
                        pointerEvents: "none",
                      }}
                    >
                      {item.node.name}
                    </Button>
                  </>
                ))}
                {myPage && ability == "can_edit" && (
                  <span
                    className="lnr lnr-pencil ema__color__blue pointer ml-2"
                    onClick={() => setAreaEdit(!areaEdit)}
                  ></span>
                )}
              </>
            )}
          </td>
        </tr>
        {/* Target Field */}
        <tr style={{ fontSize: "13.2px", borderBottom: "solid 1px #dedfec" }}>
          <th className="py-2 pl-4" style={{ width: "12%" }}>
            対象者
          </th>
          <td>
            {myPage && ability == "can_edit" && targetEdit ? (
              <>
                {allTarget.allTarget.edges.map((item, index) => {
                  if (targetAudience.includes(item.node.id)) {
                    return (
                      <Button
                        key={index}
                        className="mr-1"
                        style={{
                          background: item.node.color
                            ? item.node.color
                            : "#44cae1",
                          border: "none",
                          color: "#fff",
                          marginBottom: 3,
                        }}
                        onClick={(e) => {
                          removeTargetAudienceArea(item.node.id);
                        }}
                      >
                        {item.node.name}
                      </Button>
                    );
                  } else {
                    return (
                      <Button
                        key={index}
                        className="mr-1"
                        style={{
                          background: "#b9b9b9",
                          border: "none",
                          color: "#fff",
                          marginBottom: 3,
                        }}
                        onClick={(e) => {
                          addTargetAudienceArea(item.node.id);
                        }}
                      >
                        {item.node.name}
                      </Button>
                    );
                  }
                })}
                <Button
                  className="ema__btn__sm_update mx-2"
                  onClick={() =>
                    updateActivity(setTargetEdit, target, setActField)
                  }
                >
                  更新
                </Button>
                <CloseIcon
                  fontSize="17px"
                  onClick={(e) => {
                    setTargetEdit(!targetEdit);
                  }}
                />
              </>
            ) : (
              <>
                {target.edges.map((item, index) => (
                  <>
                    <Button
                      key={index}
                      className="mr-1"
                      style={{
                        background: item.node.color
                          ? item.node.color
                          : "#44cae1",
                        border: "none",
                        color: "#fff",
                        marginBottom: 3,
                        pointerEvents: "none",
                      }}
                    >
                      {item.node.name}
                    </Button>
                  </>
                ))}
                {myPage && ability == "can_edit" && (
                  <span
                    className="lnr lnr-pencil ema__color__blue pointer ml-2"
                    onClick={() => setTargetEdit(!targetEdit)}
                  ></span>
                )}
              </>
            )}
          </td>
        </tr>
      </table>
    </>
  );
};

export default ActivityContent;
